module.exports = __webpack_public_path__ + "MindShapesPattern.png";